import { ca } from '@cian/analytics';
import { ENotificationFrequency } from '../../../repositories/monolithPython/v1/create-subscription';

export function trackSubscribeSave(
  frequency: ENotificationFrequency,
  isPushCheck: boolean,
) {
  //tslint:disable-next-line:no-any
  const notificationFrequencyMapper: any = {
    [ENotificationFrequency.EveryDay]: 'Daily',
    [ENotificationFrequency.EveryHour]: 'Hourly',
    [ENotificationFrequency.EveryWeek]: 'Weekly',
  };

  ca('event', {
    name: 'oldevent',
    category: 'subscription',
    action: 'Send',

    label: `From_card_save/${ notificationFrequencyMapper[frequency] }/${ isPushCheck ? 'PushOn' : 'PushOff' }`,
  });
}

export function trackSubscribeWithNews() {
  ca('event', {
    name: 'oldevent',
    category: 'subscription',
    action: 'Send',
    label: 'news_From_cat_save',
  });
}
